export var STORAGE_TYPES = {
    UPLOAD: 'upload',
    FETCH: 'fetch',
    PRIVATE: 'private',
    AUTHENTICATED: 'authenticated',
    SPRITE: 'sprite',
    FACEBOOK: 'facebook',
    TWITTER: 'twitter',
    YOUTUBE: 'youtube',
    VIMEO: 'vimeo',
    MULTI: 'multi',
    INSTAGRAM: 'instagram',
    HULU: 'hulu',
    ANIMOTO: 'animoto',
    DAILYMOTION: 'dailymotion'
};
export var RESOURCE_TYPES = {
    IMAGE: 'image',
    VIDEO: 'video',
    RAW: 'raw'
};
export var VIDEO_SOURCE_TYPES = {
    WEBM: 'webm',
    MP4: 'mp4',
    OGV: 'ogv',
    FLV: 'flv',
    M3U8: 'm3u8',
    TS: 'ts',
    MOV: 'mov',
    MKV: 'mkv',
    MPD: 'mpd'
};
export var ImageFormats = {
    GIF: "gif",
    PNG: "png",
    JPG: "jpg",
    BMP: "bmp",
    ICO: "ico",
    PDF: "pdf",
    TIFF: "tiff",
    EPS: "eps",
    JPC: "jpc",
    JP2: "jp2",
    PSD: "psd",
    WEBP: "webp",
    ZIP: "zip",
    SVG: "svg",
    WDP: "wdp",
    HDX: "hpx",
    DJVU: "djvu",
    AI: "ai",
    FLIF: "flif",
    BPG: "bpg",
    MIFF: "miff",
    TGA: "tga",
    HEIC: "heic",
};
